import classNames from 'classnames';
import React from 'react';
import { InterviewMarkerList } from '../../../components/Interview/InterviewMarkerList';
import { MenuType } from '../../../components/Interview/MenuType';
import { Interview } from '../../../entities/Interview';
import { InterviewAutomaticQuestion } from '../../../entities/InterviewAutomaticQuestion';
import { InterviewMarker } from '../../../entities/InterviewMarker';
import styles from './styles.module.scss';
import { InterviewHighlightsHeader } from './InterviewHighlightsHeader';
import { HighlightType } from '../Entities/HighlightType';

export interface PropTypes {
  playTimestamp: number;
  interview: Interview;
  menuType: MenuType;
  selectedHighlightType: HighlightType;
  onSelectTimestamp?: (timestamp: number) => void;
  onUpdateInterviewMarkers: (interview_markers: InterviewMarker[]) => void;
  onUpdateInterviewAutomaticQuestions: (
    interviewAutomaticQuestions: InterviewAutomaticQuestion[],
  ) => void;
  setSelectedHighlightType: (highlighType: HighlightType) => void;
}

export function InterviewHighlightsTab(props: PropTypes) {
  return (
    <>
      <div
        className={classNames(
          'd-flex',
          'flex-column',
          'align-items-start',
          styles.notesWrapper,
          'interview_detail_highlights',
        )}
      >
        <InterviewHighlightsHeader
          selectedHighlightType={props.selectedHighlightType}
          onSelectedHighlightType={props.setSelectedHighlightType}
        />
        <div
          className={classNames(
            'p-2',
            'mb-2',
            'w-100',
            'h-100',
            'overflow-auto',
          )}
          style={{ scrollBehavior: 'smooth' }}
        >
          <InterviewMarkerList
            {...props}
            selectedHighlightType={props.selectedHighlightType}
            menuType={'reply'}
          />
        </div>
      </div>
    </>
  );
}
